import React from 'react';

const Privacypolicy = () => {
    return (
        <div className="bg-white">
            {/* Banner Section */}
            <div className="bg-brand-orange py-16 px-4 text-center">
                <div className="max-w-4xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-white mb-4">
                        Privacy Policy
                    </h2>
                    <p className="text-white text-lg opacity-90 leading-relaxed max-w-2xl mx-auto">
                        Your privacy is important to us. Here is how we safeguard your data.
                    </p>
                </div>
            </div>

            <div className="container mx-auto px-4 py-16 max-w-4xl">
                <div className="prose max-w-none text-gray-600 leading-relaxed">

                    <div className="mb-10">
                        <h2 className="text-3xl font-bold text-gray-800 mb-4">Introduction</h2>
                        <p>Welcome to Getfast Education. Your privacy is of utmost importance to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your personal information when you use our platform. By accessing Getfast Education, you agree to the terms outlined in this policy.</p>
                    </div>

                    <div className="mb-10 p-8 bg-gray-50 rounded-2xl border border-gray-100">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Information We Collect</h2>
                        <p className="mb-4">To provide you with the best user experience, we may collect the following types of information:</p>

                        <h5 className="font-bold text-gray-800 mb-2">Personal Information</h5>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Name, email address, and contact number (when you register, contact us, or subscribe to our newsletters).</li>
                            <li>Any other details you voluntarily provide through contact forms or inquiries.</li>
                            <li>IP address, browser type, and device details.</li>
                            <li>Pages visited, time spent on our website, and browsing behavior.</li>
                        </ul>
                    </div>

                    <div className="mb-10">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">How We Use Your Information</h2>
                        <ul className="list-disc pl-5 space-y-2">
                            <li><strong>Providing Information:</strong> Ensuring accurate and up-to-date details about universities, courses, and admission processes.</li>
                            <li><strong>Enhancing User Experience:</strong> Personalizing content based on your preferences and browsing behavior.</li>
                            <li><strong>Improving Website Performance:</strong> Analyzing user behavior to enhance functionality and fix potential issues.</li>
                            <li><strong>Communication & Support:</strong> Responding to inquiries, feedback, and customer service requests.</li>
                        </ul>
                    </div>

                    <div className="mb-10">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Data Security & Protection</h2>
                        <p className="mb-4">We take appropriate measures to safeguard your personal data from unauthorized access, alteration, disclosure, or destruction. These include:</p>
                        <ul className="list-disc pl-5 space-y-2">
                            <li>Secure servers and encrypted databases to store sensitive information.</li>
                            <li>Limited access to personal data by authorized personnel only.</li>
                            <li>Regular security updates and vulnerability scans to prevent cyber threats.</li>
                        </ul>
                    </div>

                    <div className="mb-10">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Third-Party Links & External Websites</h2>
                        <p>Getfast Education may contain links to third-party websites, including universities, admission portals, and educational resources. These external sites have their own privacy policies, and we do not take responsibility for their content, data practices, or security.</p>
                    </div>

                    <div className="mb-10">
                        <h2 className="text-2xl font-bold text-gray-800 mb-4">Modifications & Updates to Privacy Policy</h2>
                        <p>Getfast Education reserves the right to modify, update, or revise this Privacy Policy at any time without prior notice. We encourage users to review this page periodically for the latest updates.</p>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default Privacypolicy;
